import { Formik, Form } from "formik";
import { MedicalTravelModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import {
  Box,
  Button,
  ErrorList,
  handleSubmitClick,
  InputText,
  Progressbar,
} from "@ogt/ui";

export default function RefundInfo() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 25;

  return (
    <div>
      <Formik<MedicalTravelModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/reseuppgifter");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          clearingNumber: Yup.string().required(
            "Vänligen fyll i ditt clearingnummer"
          ),
          accountNumber: Yup.string().required(
            "Vänligen fyll i ditt kontonummer"
          ),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-between items-center">
              <div className="flex justify-center h-15 md:h-auto mb-1">
                <div className="w-full text-left md:hidden">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
              </div>

              <div className="w-40 xs:w-52 md:w-full max-w-xs md:mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <h2 ref={h2Ref} tabIndex={-1} id="">
                  Kontouppgifter för utbetalning
                </h2>

                <p>
                  Ange clearing- och kontonummer för det konto som ersättningen
                  ska betalas ut till.
                </p>
                <p className="mb-8">
                  Ange endast siffror, eventuella bindestreck, punkter eller
                  mellanslag tas automatiskt bort.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <InputText
                  name="clearingNumber"
                  label={
                    <>
                      Clearingnummer <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="number"
                  numbersOnly
                  autocomplete={"off"}
                  moreinfo="Endast siffror"
                />
                <InputText
                  name="accountNumber"
                  label={
                    <>
                      Kontonummer <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="number"
                  numbersOnly
                  autocomplete={"off"}
                  moreinfo="Endast siffror"
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn secondary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
